import React from 'react';
import { components } from 'react-select';

const OptionContainer = (props) => <components.Option {...props} />;

export default OptionContainer;
